export default __webpack_public_path__ + "static/media/arc.892e4ad7.svg";